import { createSlice } from "@reduxjs/toolkit";
// import SavedProduct from "pages/store/saveproduct";

export const productSlice = createSlice({
  name: "product",
  initialState: {
    data: [],
    productSavedByUser: [],
    productDeleteByUser: [],
    productDetails: {},
  },
  reducers: {
    setProduct: (state, { payload }) => {
      state.data = {...state.data, product: payload }
      // state.allProducts = payload;
    },
    productSaved: (state, { payload }) => {
      state.productSavedByUser = {...state.productSavedByUser, saved: payload }
      // state.productSavedByUser = payload;
      // state.allProducts = payload;
    },
    // productDelete: (state, { payload }) => {
    //   state.data = {...state.data, delete: payload }
    //   // state.allProducts = payload;
    // },
    setProductDetails: (state, { payload }) => {
      // state.data = {...state.data, product: payload }
      state.productDetails = payload;
    },
  },
});

export const { setProduct, setProductDetails, productSaved, productDelete, } = productSlice.actions;

export default productSlice.reducer;
